/**
 * Foundry Design System Colors
 *
 * Brand colors for the Aerware Foundry UI.
 */

export const colors = {
  // Core backgrounds
  obsidian: '#0B0F16',
  ironCharcoal: '#1A1E24',
  forgeSteel: '#3A3F47',

  // Text and accents
  sandstone: '#E8E3DC',
  softSand: '#F3E7DA',
  secondaryText: '#A8A8B8',

  // Brand colors
  foundryCopper: '#D97A36',
  emberOrange: '#FF8F4F',
  moltenGold: '#FFC65A',

  // Status colors
  electricTeal: '#19C3FF',
  neonMint: '#19FFCB',

  // Additional accents
  purple: '#9B87F5',
} as const;

export type ColorKey = keyof typeof colors;

// Team color mapping
export const teamColors: Record<string, string> = {
  Management: colors.moltenGold,
  Engineering: colors.electricTeal,
  Marketing: colors.foundryCopper,
  Research: colors.neonMint,
  Product: colors.purple,
  Operations: colors.emberOrange,
  Finance: colors.neonMint,
};

// Team color palette for rotation-based assignment (custom teams)
// Uses only brand-approved accent colors per BRANDING.md
export const teamColorPalette: string[] = [
  colors.electricTeal,    // 1 - Engineering default
  colors.foundryCopper,   // 2 - Marketing default
  colors.neonMint,        // 3 - Research default
  colors.moltenGold,      // 4 - Product default
  colors.emberOrange,     // 5 - Operations default
  colors.purple,          // 6 - Finance default
];
// Teams 7+ cycle back through palette (team 7 = color 1, etc.)

// Status color mapping
export const statusColors: Record<string, string> = {
  active: colors.neonMint,
  idle: colors.moltenGold,
  pending: colors.emberOrange,
  offline: colors.forgeSteel,
  complete: colors.neonMint,
  review: colors.electricTeal,
};

// Role color mapping (user permission levels)
export const roleColors: Record<string, string> = {
  admin: colors.moltenGold,
  staff: colors.electricTeal,
  viewer: colors.purple,
};

export function getTeamColor(team: string): string {
  return teamColors[team] || colors.forgeSteel;
}

// Get color for custom team by creation order (0-based index)
export function getTeamColorByIndex(index: number): string {
  return teamColorPalette[index % teamColorPalette.length];
}

export function getStatusColor(status: string): string {
  return statusColors[status] || colors.forgeSteel;
}

export function getRoleColor(role: string): string {
  return roleColors[role] || colors.forgeSteel;
}
